import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Shield, Users, Globe2, Award } from "lucide-react";

function AboutPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ArrowLeft size={20} className="mr-2" />
              Назад
            </Button>
          </Link>
          <h1 className="font-heading text-xl font-bold text-primary">О НАС</h1>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <h2 className="text-3xl font-bold text-foreground mb-8">О компании <span className="text-primary">Skinkosh</span></h2>
        
        <div className="prose prose-invert max-w-none space-y-6 text-muted-foreground">
          <p className="text-lg">
            Skinkosh — это современный сервис обмена криптовалют, основанный в 2020 году. 
            Мы предоставляем быстрый, безопасный и удобный способ обмена цифровых активов.
          </p>

          <div className="grid md:grid-cols-2 gap-6 my-8">
            <div className="p-6 bg-card border border-border rounded-lg">
              <Shield className="text-primary mb-4" size={32} />
              <h3 className="font-bold text-foreground mb-2">Безопасность</h3>
              <p className="text-sm">Все транзакции защищены современными протоколами шифрования. Мы не храним ваши средства.</p>
            </div>
            <div className="p-6 bg-card border border-border rounded-lg">
              <Users className="text-primary mb-4" size={32} />
              <h3 className="font-bold text-foreground mb-2">Доверие</h3>
              <p className="text-sm">Более 50,000 довольных клиентов по всему миру доверяют нам свои обмены.</p>
            </div>
            <div className="p-6 bg-card border border-border rounded-lg">
              <Globe2 className="text-primary mb-4" size={32} />
              <h3 className="font-bold text-foreground mb-2">Глобальность</h3>
              <p className="text-sm">Мы работаем в более чем 150 странах мира, обеспечивая доступ к обмену 24/7.</p>
            </div>
            <div className="p-6 bg-card border border-border rounded-lg">
              <Award className="text-primary mb-4" size={32} />
              <h3 className="font-bold text-foreground mb-2">Опыт</h3>
              <p className="text-sm">5+ лет успешной работы на рынке криптовалютных обменов.</p>
            </div>
          </div>

          <h3 className="text-xl font-bold text-foreground mt-8">Наша миссия</h3>
          <p>
            Мы стремимся сделать обмен криптовалют максимально простым и доступным для каждого. 
            Наша цель — предоставить пользователям надёжный инструмент для работы с цифровыми активами 
            без сложных процедур регистрации и верификации.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">Преимущества работы с нами</h3>
          <ul className="list-disc list-inside space-y-2">
            <li>Мгновенный обмен без регистрации</li>
            <li>Минимальные комиссии от 1%</li>
            <li>Поддержка более 20 криптовалют</li>
            <li>Круглосуточная поддержка в Telegram</li>
            <li>Прозрачные условия без скрытых платежей</li>
            <li>Быстрое зачисление средств</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">Контакты</h3>
          <p>
            Email: support@skinkosh.com<br />
            Telegram: <a href="https://t.me/skinkosh" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">@skinkosh</a><br />
            Время работы: 24/7
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
